module.exports = __webpack_public_path__ + "img/149.f4c938ae.jpg";